import { useTranslation } from "react-i18next";

export function useServices() {
  const { t } = useTranslation();

  return [
    {
      id: "musicAndEntertainment",
      name: t("categories.musicAndEntertainment"),
      description: t("categories.musicAndEntertainmentDescription", {
        defaultValue:
          "Bring life to your events with live music and captivating performances.",
      }),
      imageUrl:
        "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Services/Musique%20et%20Animation.png",
    },
    {
      id: "activitiesAndEntertainment",
      name: t("categories.activitiesAndEntertainment"),
      description: t("categories.activitiesAndEntertainmentDescription", {
        defaultValue:
          "Create unforgettable experiences with interactive and fun activities.",
      }),
      imageUrl:
        "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Services/Activites%20et%20divertissements.webp",
    },
    {
      id: "foodAndDrinks",
      name: t("categories.foodAndDrinks"),
      description: t("categories.foodAndDrinksDescription", {
        defaultValue:
          "Discover culinary options tailored for every taste and occasion.",
      }),
      imageUrl:
        "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Services/Nourriture%20et%20boissons.webp",
    },
    {
      id: "spaceRentals",
      name: t("categories.spaceRentals"),
      description: t("categories.spaceRentalsDescription", {
        defaultValue:
          "Find the perfect venue to host your event, indoors or outdoors.",
      }),
      imageUrl:
        "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Services/Location%20d_espaces%20(3).webp",
    },
    {
      id: "photographyAndVideography",
      name: t("categories.photographyAndVideography"),
      description: t("categories.photographyAndVideographyDescription", {
        defaultValue:
          "Capture every moment with professional photo and video services.",
      }),
      imageUrl:
        "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Services/Photographie%20et%20videographie%20(3).webp",
    },
    {
      id: "decorations",
      name: t("categories.decorations"),
      description: t("categories.decorationsDescription", {
        defaultValue:
          "Enhance your event's ambiance with stunning decorations.",
      }),
      imageUrl:
        "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Services/Decorations.webp",
    },
    {
      id: "technologyAndAV",
      name: t("categories.technologyAndAV"),
      description: t("categories.technologyAndAVDescription", {
        defaultValue:
          "Equip your event with state-of-the-art audio and visual technology.",
      }),
      imageUrl:
        "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Services/Technologie%20et%20audiovisuel.webp",
    },
    {
      id: "structuresAndTents",
      name: t("categories.structuresAndTents"),
      description: t("categories.structuresAndTentsDescription", {
        defaultValue:
          "Tents, marquees, flooring, risers and stages to shape your spaces.",
      }),
      imageUrl:
        "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Services/Structures%20et%20tentes.webp",
    },
    {
      id: "lightingAndEffects",
      name: t("categories.lightingAndEffects"),
      description: t("categories.lightingAndEffectsDescription", {
        defaultValue:
          "Architectural/ambient lighting, string lights and light special effects.",
      }),
      imageUrl:
        "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/eclairageeteffets.webp",
    },
    {
      id: "personalizedServices",
      name: t("categories.personalizedServices"),
      description: t("categories.personalizedServicesDescription", {
        defaultValue:
          "Get tailored services to make your event smooth and memorable.",
      }),
      imageUrl:
        "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Produitspersonnalisesetcadeaux.png",
    },
    {
      id: "transportation",
      name: t("categories.transportation"),
      description: t("categories.transportationDescription", {
        defaultValue:
          "Organize transportation with ease for guests and equipment.",
      }),
      imageUrl:
        "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Services/transport.webp",
    },
    {
      id: "safetyAndHealth",
      name: t("categories.safetyAndHealth"),
      description: t("categories.safetyAndHealthDescription", {
        defaultValue:
          "Ensure the safety and well-being of everyone with health and security services.",
      }),
      imageUrl:
        "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Services/securiteetsante.webp",
    },
  ];
}
